import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class FFHBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ffhTopic, ffhTitle, ffhList, ffhBoxData },
        } = this.props;

        return (
            <div id="ffhNewsList" className={styles.ffh_box}>
                <Chip id="50082" type="struct" title="大风号栏标题" groupName="大风号栏" content={ffhTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75113"
                    type="recommend"
                    title="大风号栏头条"
                    groupName="大风号栏"
                    content={ffhTitle}
                    translate="handleFFHNewsData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75114"
                    type="recommend"
                    title="大风号栏新闻列表"
                    groupName="大风号栏"
                    content={ffhList}
                    translate="handleFFHNewsData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75115"
                    type="recommend"
                    title="大风号栏新闻盒"
                    groupName="大风号栏"
                    content={ffhBoxData}
                    translate="handleNewsBoxData">
                    <NewsBox />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FFHBox);
